import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Color } from '../../../app/StyleGuide';

const ringDraw = keyframes`
	from {
		stroke-dashoffset: 264;
	}

	to {
		stroke-dashoffset: 0;
	}
`;

const circleReveal = keyframes`
	from {
		opacity: 0;
	}

	99% {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
`;

const shortCheckDraw = keyframes`
	from {
		stroke-dashoffset: 20;
	}

	to {
		stroke-dashoffset: 0;
	}
`;

const longCheckDraw = keyframes`
	from {
		stroke-dashoffset: 40;
	}

	to {
		stroke-dashoffset: 0;
	}
`;

const SuccessIcon = styled.div`
  width: 92px;
  height: 92px;
  display: grid;
  place-items: center;

  svg {
    width: 100%;
    height: 100%;
  }

  .ring {
    fill: none;
    stroke: ${Color.Primary._50};
    stroke-width: 6;
    stroke-linecap: round;
    stroke-dasharray: 264;
    stroke-dashoffset: 264;
    animation: ${ringDraw} 360ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }

  .fill {
    fill: ${Color.Primary._50};
    opacity: 0;
    animation: ${circleReveal} 1ms linear 340ms forwards;
  }

  .checkShort,
  .checkLong {
    fill: none;
    stroke: ${Color.white};
    stroke-width: 8;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 40;
    stroke-dashoffset: 40;
  }

  .checkShort {
    stroke-dasharray: 20;
    stroke-dashoffset: 20;
    animation: ${shortCheckDraw} 260ms cubic-bezier(0.22, 1, 0.36, 1) 480ms forwards;
  }

  .checkLong {
    animation: ${longCheckDraw} 340ms cubic-bezier(0.22, 1, 0.36, 1) 720ms forwards;
  }

  @media (prefers-reduced-motion: reduce) {
    .ring,
    .fill,
    .checkShort,
    .checkLong {
      animation: none;
      opacity: 1;
      stroke-dashoffset: 0;
    }
  }
`;

export const SuccessCheckmarkIcon = () => (
  <SuccessIcon>
    <svg viewBox="0 0 96 96" role="img" aria-label="successfully completed">
      <circle className="fill" cx="48" cy="48" r="42" />
      <circle className="ring" cx="48" cy="48" r="42" />
      <path className="checkShort" d="M28 50 L42 64" pathLength={20} />
      <path className="checkLong" d="M42 64 L68 34" pathLength={40} />
    </svg>
  </SuccessIcon>
);
